<template>
  <v-dialog
      v-model="model"
      scrollable
      @click:outside="fecharModal"
      :persistent="persistencia"
      :max-width="maxWidth"
      style="padding: 0">
    <v-card class="card-component">
      <v-toolbar dark color="primary" elevation="0">
        <v-toolbar-title>{{ titulo }}</v-toolbar-title>
        <v-spacer/>
        <v-btn class="close__button" text @click="cancelar" icon>
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text style="color: black">
        <div v-if="qrCode" class="container-qr-code">
          <v-img :src="qrCode" alt="QR Code"/>
        </div>
        <div v-if="loading" class="container-qr-code">
          <v-progress-circular
              color="primary"
              size="54"
              indeterminate
          />
        </div>
        <div v-if="!qrCode && !loading" class="container-qr-code">
          <label>Não foi possível gerar o QRCode, tente novamente.</label>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import QRCode from 'qrcode'

export default {
    name: 'QRCodeModal',
    props: {
        value: {
            type: Boolean,
            required: true
        },
        persistencia: {
            type: Boolean,
            default: false
        },
        maxWidth: {
            type: Number,
            default: 400
        },
        titulo: {
            type: String,
            default: 'QR Code'
        },
        textoQRCode: {
            type: String,
            default: '/'
        },
    },
    data() {
        return {
            loading: false,
            qrCode: null
        }
    },
    computed: {
        model: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        }
    },
    async mounted() {
        await this.gerarQrCode()
    },
    methods: {
        async gerarQrCode() {
            try {
                this.loading = true
                this.qrCode = await QRCode.toDataURL(this.textoQRCode)
            } catch (err) {
                this.loading = false
                console.log('Falha ao gerar o QRCode')
                console.error(err)
            } finally {
                this.loading = false
            }
        },
        fecharModal() {
            if (!this.persistencia) {
                this.cancelar()
            }
        },
        cancelar() {
            this.model = false
            this.$emit('modalQRCodeFechar')
        },
    }

}
</script>

<style scoped lang="stylus">
.card-component
  text-align start
  background-color #FFFFFF
  color #000000

.container-qr-code
  display flex
  justify-content center
  align-items center
  min-height 300px

</style>